export default __webpack_public_path__ + "static/media/post-company-3.362c9c62.png";